import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ThemeMode, ColorTheme, ColorMode, ThemeState } from './types';

// Default to LIGHT mode on a fresh visit (no persisted theme state).
// Existing users keep whatever theme they previously chose because
// `redux-persist` rehydrates over this initial state — bump the persist
// version (see apps/*/store.ts) to also reset users still on the old
// dark default.
const initialState: ThemeState = {
  mode: 'light',
  colorTheme: 'blue',
  colorMode: 'multi',
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleMode(state) {
      state.mode = state.mode === 'light' ? 'dark' : 'light';
    },
    setMode(state, action: PayloadAction<ThemeMode>) {
      state.mode = action.payload;
    },
    setColorTheme(state, action: PayloadAction<ColorTheme>) {
      state.colorTheme = action.payload;
    },
    setColorMode(state, action: PayloadAction<ColorMode>) {
      state.colorMode = action.payload;
    },
  },
});

export const { toggleMode, setMode, setColorTheme, setColorMode } = themeSlice.actions;
export default themeSlice.reducer;
